module.exports = __webpack_public_path__ + "cy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cy.svg
// module id = 512
// module chunks = 0